import React, { useState } from 'react';
import './CreateUser.css';
import { useNavigate, useParams } from 'react-router-dom';
const config=require( '../../config.js');
const translations = {
    english: {
        role: "Role",
        RoleHelp: "Role",
        email: "Email Address",
        alreadyRegistered: "Already Registered? Go to login page.",
        signup: "Save",
        failed: "Registration failed",
    },
    german: {
        role: "Role",
        RoleHelp: "Role",
        email: "E-Mail Adresse",
        alreadyRegistered: "Bereits registriert? Gehen Sie zur Login-Seite.",
        signup: "Save",
        failed: "Registrierung ist fehlgeschlagen",
    },
    italian: {
        role: "Role",
        RoleHelp: "Role",
        email: "Indirizzo Email",
        alreadyRegistered: "Già registrato? Vai alla pagina di accesso.",
        signup: "Salva",
        failed: "Registrazione fallita"
    },
    czech: {
        role: "Role",
        RoleHelp: "Role",
        email: "Emailová Adresa",
        alreadyRegistered: "Již registrováni? Přejděte na přihlašovací stránku.",
        signup: "Save",
        failed: "Registrace se nezdařila"
    }
};

function UserRole() {
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
    const lang = translations[currentLanguage];
    const { id, fromRole } = useParams();
    const [role, setRole] = useState(fromRole);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        try {
            const response = await fetch(config.env.API_BASE_URL+'/api/users/'+ id + '/role', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    role
                })
            });

            if (response.ok) {
                setSuccess(response.data);
                setRole('');
                alert('User saved successfully!');
                navigate('/users');
            } else {
                const errorData = await response.text();
                alert(`Failed to save user: ${errorData}`);
            }
        } catch (error) {
            setError(error.response ? error.response.data.message : lang.failed);
        }
    };

    return (
        <div className='loginandsignup-main'>
            <div className='d-flex justify-content-center align-items-center flex-column gap-4'>
                <section className='loginandsignup'>
                    <form onSubmit={handleSubmit}>
                        {error && <p className='error-message'>{error}</p>}
                        {success && <p className='success-message'>{success}</p>}
                        <div className={`input-wrap ${role ? 'has-value' : ''}`}>
                            <select onLoad={() => setRole(fromRole)}
                                className='login-inputSelect'
                                aria-placeholder={lang.role}
                                value={role}
                                onChange={(e) => {setRole(e.target.value)}}
                            >
                                <option value="users">User</option>
                                <option value="third">Third</option>
                                <option value="expert">Expert</option>                                
                                <option value="admin">Admin</option>
                            </select>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <button type='submit' className='btn-signup'>{lang.signup}</button>
                        </div>
                    </form>
                </section>
            </div>
        </div>
    );
}

export default UserRole;
